module.exports = __webpack_public_path__ + "img/dateSingedEle.e3cb87df.svg";